import(/* webpackMode: "eager" */ "/app/apps/frontend/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["AuthModal"] */ "/app/apps/frontend/components/auth-modal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/app/apps/frontend/components/auth-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CommandPalette"] */ "/app/apps/frontend/components/command-palette.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ErrorBoundary"] */ "/app/apps/frontend/components/error-boundary.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HydrationGuard"] */ "/app/apps/frontend/components/hydration-guard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NavLoader"] */ "/app/apps/frontend/components/nav-loader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/app/apps/frontend/components/theme-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TrackingInit"] */ "/app/apps/frontend/components/tracking-init.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/app/apps/frontend/components/ui/sonner.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/frontend/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/apps/frontend/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"variable\":\"--font-sans\",\"subsets\":[\"latin\",\"cyrillic\"],\"display\":\"swap\",\"axes\":[\"opsz\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/app/apps/frontend/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Playfair_Display\",\"arguments\":[{\"variable\":\"--font-display\",\"subsets\":[\"latin\",\"cyrillic\"],\"weight\":[\"400\",\"500\",\"600\",\"700\",\"800\"],\"display\":\"swap\"}],\"variableName\":\"playfair\"}");
